import type {
  CustomInstrumentDetails,
  CustomInstrumentInfo,
  CustomInstrumentTimeSeries,
  CustomInstrumentUsage,
} from "@repo/shared/types";
import { del, get, patch, post } from "@/lib/api/_client";

const BASE = "/internal/custom-instruments";

export function list(): Promise<CustomInstrumentInfo[]> {
  return get(BASE);
}

export function getByTicker(ticker: string): Promise<CustomInstrumentDetails> {
  return get(`${BASE}/${ticker}`);
}

export function create(data: {
  name: string;
  nameI18n?: Record<string, string>;
  ticker: string;
  currency: string;
  data: CustomInstrumentTimeSeries[];
}): Promise<CustomInstrumentInfo> {
  return post(BASE, data);
}

export function update(
  ticker: string,
  data: {
    name: string;
    nameI18n?: Record<string, string>;
    ticker: string;
    currency: string;
    data: CustomInstrumentTimeSeries[];
  },
): Promise<{ success: boolean }> {
  return patch(`${BASE}/${ticker}`, data);
}

export function remove(ticker: string): Promise<{ success: boolean }> {
  return del(`${BASE}/${ticker}`);
}

export function getUsage(ticker: string): Promise<CustomInstrumentUsage> {
  return get(`${BASE}/${ticker}/usage`);
}

export function getStatistics(
  ticker: string,
  currency: string,
): Promise<{ expectedReturn: number; expectedVolatility: number }> {
  return post(`${BASE}/${ticker}/statistics`, { currency });
}
